import { urlrefresh } from './custom'

export const refreshToken = async () => {
  try {
    const refreshTokenFetch = await fetch(`${urlrefresh}`, {
      method: 'POST',
      headers: {
        'X-Raund-Token': `${process.env.NEXT_PUBLIC_RAUND_TOKEN}`,
      },
      body: JSON.stringify({
        refresh_token: localStorage.getItem(
          `${process.env.NEXT_PUBLIC_SERVICE_NAME}-refresh`
        ),
        username: localStorage.getItem(
          `${process.env.NEXT_PUBLIC_SERVICE_NAME}-username`
        ),
      }),
    })

    const res = await refreshTokenFetch.json()
    const result = res.result
    console.log(result)

    if (result.status === 200) {
      localStorage.setItem(
        `${process.env.NEXT_PUBLIC_SERVICE_NAME}-jwt`,
        result.id_token
      )

      location.reload()
    }

    if (result.status === 403 || result.status === 400) {
      console.log(result.message)

      localStorage.clear()
      location.href = `${process.env.NEXT_PUBLIC_SITEURL}/${process.env.NEXT_PUBLIC_SERVICE_NAME}/auth/signin`
    }

    if (result.status === 500) {
      console.log(result.message)
      localStorage.clear()
      location.href = `${process.env.NEXT_PUBLIC_SITEURL}/${process.env.NEXT_PUBLIC_SERVICE_NAME}/auth/signin`
    }
  } catch (error) {
    console.log(error)
  }
}
